<mat-card-content style="height:100%">
<mat-list-item>
  <mat-toolbar style="background-color: white;">{{ 'dedicacionsSetmanals.titol' | translate:{ tipus: tipus } }}
    <mat-icon color="primary" title="{{ 'dedicacionsSetmanals.canviarToolTip' | translate }}" style="float: left; clear: none; font-size: 24px; padding-left: 1%; cursor: pointer;" (click)="navigate()">calendar_today
  </mat-icon>
</mat-toolbar>
<mcrit-time-table-week
    [tipus]="tipus"
    [projectList]="projectList"
    (hourChanges)="dispatch($event)">
  </mcrit-time-table-week>
</mat-list-item>
</mat-card-content>